import {
  VerifyResDocument,
  VerifyResMutationVariables,
} from "@graphql/api";
import { setAuthToken } from "@lib/auth/jwt";

export default async function verifyRes(
  resId: string,
  validationMode: string,
  validationValue?: string
): Promise<string | false> {
  const client = global.window.apolloClient;

  const mutVars: VerifyResMutationVariables = { 
    resId, 
    validationMode, 
    validationValue: validationValue || "" 
  };
  
  const result = await client.mutate({
    mutation: VerifyResDocument,
    variables: mutVars,
  });

  // Check if the mutation was successful
  if (!result.data?.verifyRes?.success) {
    return false;
  }

  // Handle JWT token update if provided
  if (result.data.verifyRes.auth?.token) {
    // Store the new JWT token in cookies
    setAuthToken(result.data.verifyRes.auth.token);
    
    // Reset Apollo store to use the new token for subsequent requests
    await client.resetStore();
  }

  // Return the verified reservation ID
  return result.data.verifyRes.resId?.toString() || false;
}